import { render, staticRenderFns } from "./Insert.vue?vue&type=template&id=3242082f&scoped=true"
import script from "./Insert.vue?vue&type=script&lang=js"
export * from "./Insert.vue?vue&type=script&lang=js"
import style0 from "./Insert.vue?vue&type=style&index=0&id=3242082f&prod&scoped=true&lang=css"
import style1 from "./Insert.vue?vue&type=style&index=1&id=3242082f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3242082f",
  null
  
)

export default component.exports